import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalInnerFn = /* @__PURE__ */ createRecipe('modal-inner', {}, [])

const modalInnerVariantMap = {}

const modalInnerVariantKeys = Object.keys(modalInnerVariantMap)

export const modalInner = /* @__PURE__ */ Object.assign(memo(modalInnerFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalInner',
  __getCompoundVariantCss__: modalInnerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalInnerVariantKeys,
  variantMap: modalInnerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalInnerVariantKeys)
  },
  getVariantProps: modalInnerFn.getVariantProps,
})